import React, { useEffect, useRef } from "react";

const Testimonials = () => {
  const owlCarouselRef = useRef(null);

  // Initialize owl carousel after component mounts
  useEffect(() => {
    // Check if the owl carousel library is loaded properly
    const initializeOwlCarousel = () => {
      // Make sure jQuery and owlCarousel are available globally
      if (window.jQuery && typeof window.jQuery.fn.owlCarousel === 'function') {
        // Initialize the carousel
        const $ = window.jQuery;
        $(owlCarouselRef.current).owlCarousel({
          loop: true,
          margin: 20,
          nav: false,
          dots: true,
          responsive: {
            0: { items: 1 },
            768: { items: 1 }
          }
        });
      } else {
        // If not loaded yet, retry after a short delay
        setTimeout(initializeOwlCarousel, 500);
      }
    };

    // Start trying to initialize
    initializeOwlCarousel();

    // Cleanup function
    return () => {
      if (window.jQuery && owlCarouselRef.current) {
        try {
          // eslint-disable-next-line react-hooks/exhaustive-deps
          window.jQuery(owlCarouselRef.current).owlCarousel('destroy');
        } catch (e) {
          console.error("Error destroying owl carousel:", e);
        }
      }
    };
  }, []);

  return (
    <section className="testimonial-con position-relative">
      <div className="container">
        <div className="row">
          <div className="col-lg-1 col-md-1 col-sm-1 col-1 d-md-block d-none" data-aos="zoom-in">
            <div className="testimonial_wrapper">
              <figure className="testimonial-image1 image mb-0 position-absolute">
                <img src="https://res.cloudinary.com/dtivafy25/image/upload/v1743577323/01_2_yuiqd6.png " alt="image-0" className="img-fluid"/>
              </figure>
              <figure className="testimonial-image2 image mb-0 position-absolute">
                <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743578135/01_3_tgzqwa.png" alt="image-1" className="img-fluid"/>
              </figure>
              <figure className="testimonial-image3 image mb-0 position-absolute">
                <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743578134/06_azc9bb.png" alt="image-2" className="img-fluid"/>
              </figure>
              <figure className="testimonial-image4 image mb-0 position-absolute">
                <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743578134/08_pnd6kn.png" alt="image-3" className="img-fluid"/>
              </figure>
            </div>
          </div>
          <div className="col-lg-10 col-md-10 col-sm-12 col-12" data-aos="fade-up">
            <div className="testimonial_content_box position-relative">
              <h2 className="col-lg-8 mx-auto">Hear from Our <span>Happy Candy</span> Lovers</h2>      
              <figure className="testimonial-quoteimage mb-0 position-absolute">
                <img src="./assets/images/testimonial-quoteimage.png" alt="image-4" className="img-fluid"/>
              </figure>
            </div>
            <div ref={owlCarouselRef} className="owl-carousel owl-theme">
              <div className="item">
                <div className="testimonial_content">
                  <p className="paragraph">There’s something magical about unwrapping a piece of candy—it’s like a tiny burst of happiness in every bite! Whether I need a quick pick-me-up during a busy day or just want to indulge in something sweet, this candy never fails to satisfy.
                  </p>
                  <span className="name">Arjun Mehra</span>
                  <span className="review">Happy Customer</span>
                  <ul className="list-unstyled mb-0">
                    <li><i className="fa-solid fa-star"></i></li>
                    <li><i className="fa-solid fa-star"></i></li>
                    <li><i className="fa-solid fa-star"></i></li>
                    <li><i className="fa-solid fa-star"></i></li>
                    <li><i className="fa-solid fa-star"></i></li>
                  </ul>
                </div>
              </div>
              <div className="item">
                <div className="testimonial_content">
                  <p className="paragraph">There’s something magical about unwrapping a piece of candy—it’s a little moment of joy in every bite! Whether it's a quick treat during a busy day or a sweet indulgence, our candy always brings smiles. 
                  </p>
                  <span className="name">Ananya Iyer</span>
                  <span className="review">Happy Customer</span>
                  <ul className="list-unstyled mb-0">
                    <li><i className="fa-solid fa-star"></i></li>
                    <li><i className="fa-solid fa-star"></i></li>
                    <li><i className="fa-solid fa-star"></i></li>
                    <li><i className="fa-solid fa-star"></i></li>
                    <li><i className="fa-solid fa-star"></i></li>
                  </ul>
                </div>
              </div>
              <div className="item">
                <div className="testimonial_content">
                  <p className="paragraph">Every bite of our candy is a moment of pure joy! Whether it’s a nostalgic treat or a sweet escape from a busy day, our candies never fail to delight.
                  </p>
                  <span className="name">Meera Nair</span>
                  <span className="review">Happy Customer</span>
                  <ul className="list-unstyled mb-0">
                    <li><i className="fa-solid fa-star"></i></li>
                    <li><i className="fa-solid fa-star"></i></li>
                    <li><i className="fa-solid fa-star"></i></li>
                    <li><i className="fa-solid fa-star"></i></li>
                    <li><i className="fa-solid fa-star"></i></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1 col-1 d-md-block d-none" data-aos="zoom-in">
            <div className="testimonial_wrapper">
              <figure className="testimonial-image5 image mb-0 position-absolute">
                <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743578134/03_guruj9.png" alt="image-5" className="img-fluid"/>
              </figure>
              <figure className="testimonial-image6 image mb-0 position-absolute">
                <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743578134/07_jcpute.png"  alt="image-6" className="img-fluid"/>
              </figure>
              <figure className="testimonial-image7 image mb-0 position-absolute">
                <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743578134/02_2_bgwk5a.png" alt="image-7" className="img-fluid"/>
              </figure>
              <figure className="testimonial-image8 image mb-0 position-absolute">
                <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743578134/05_1_e6k5u4.png" alt="image-8" className="img-fluid"/>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;